import { Component, input, output } from '@angular/core';
import { PlaylistCardShort } from '@app/app/shared/models';
import { LucideCheck } from '@lucide/angular';

@Component({
  selector: 'ptl-card-item-snake-view',
  templateUrl: './card-item-snake-view.component.html',
  styleUrls: ['./card-item-snake-view.component.scss'],
})
export class CardItemSnakeViewComponent {
  card = input<PlaylistCardShort>();
  cardIndex = input(0);

  cardClick = output<PlaylistCardShort>();

  protected readonly LucideCheck = LucideCheck;
}
